import { render, staticRenderFns } from "./GenericUserJournalCard.vue?vue&type=template&id=10995f2a"
import script from "./GenericUserJournalCard.vue?vue&type=script&lang=js"
export * from "./GenericUserJournalCard.vue?vue&type=script&lang=js"
import style0 from "./GenericUserJournalCard.vue?vue&type=style&index=0&id=10995f2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports